export default __webpack_public_path__ + "static/media/ThenaliRamen.adc95f46.png";